import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import localforage from 'localforage';
import { DatePicker, Card, message, Row, Col, Form, Button, Table, Select, Input } from 'antd';
export default function UserList() {
    const [dataSource, setState] = useState([]);
    const [firstNameArr, setFirstNameArr] = useState([]);
    const [lastNameArr, setLastNameArr] = useState([]);
    const [selectedRowsValue, setSelectedRows] = useState([]);
    const [dataSaver, setList] = useState([]);
    const [firstDataSaver, setFirstList] = useState([]);
    const [timeDataSaver, setTime] = useState([]);
    const [weightDataSaver, setWeight] = useState([]);
    const today = dayjs(); //当天日期
    // const firstValue = 'NingBo';

    useEffect(() => {
        Promise.all([
            localforage.getItem('first_Name'),
            localforage.getItem('last_Name'),
            localforage.getItem('time'),
            localforage.getItem('weight'),
        ]).then((res) => {
            // const [firstList = [], list = [], time = []] = res;
            const firstList = res[0] || [];
            const list = res[1] || [];
            const time = res[2] || [];
            const weight = res[3] || [];
            setFirstList(firstList);
            setList(list);
            setTime(time);
            setWeight(weight);
            ajax.get('/cma/getname')
                .then((response) => {
                    // 添加禁用状态 默认false
                    const data = response.map((item) => {
                        const originCity = firstList?.find((c) => c.id === item.id)?.value || '';
                        const destinationCity = list?.find((c) => c.id === item.id)?.value || '';
                        const cargo_weight = weight?.find((c) => c.id === item.id)?.value || '18600';
                        const timeValue = time?.find((c) => c.id === item.id)?.value || today.format('YYYY-MM-DD');
                        return {
                            ...item,
                            isDisabled: false,
                            originCity,
                            cargo_weight,
                            destinationCity,
                            timeValue,
                        };
                    });
                    data.sort((a, b) => a?.id - b?.id);
                    setState(data);
                })
                .catch((err) => {
                    console.log(err);
                });
        });
        // 获取起始港
        ajax.get('startport?location=1')
            .then((response) => {
                const data = response;
                setFirstNameArr(data);
            })
            .catch((err) => {
                console.log(err);
            });

        // 获取目的港
        ajax.get('endport?location=1')
            .then((response) => {
                const data = response;
                setLastNameArr(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    //多选
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // debugger;
            const selectedRowsValue = selectedRows;
            setSelectedRows(selectedRowsValue);
            let startArr = [],
                endArr = [];
            dataSource.forEach((item) => {
                let isSelect = selectedRowKeys.includes(item.id);
                if (isSelect) {
                    startArr.push(item);
                } else {
                    endArr.push(item);
                }
            });
            let newData = [...startArr, ...endArr];
            setState(newData);
        },
    };

    // 起始港下拉
    const firstChange = (value, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.originCity = value;
                    let firstDataSaverList = {
                        id: item.id,
                        value: value,
                    };
                    let firstSaverListAll = [];
                    firstSaverListAll.unshift(firstDataSaverList);
                    firstSaverListAll.forEach((el) => {
                        if (!firstDataSaver.some((e) => e.id === el.id)) {
                            firstDataSaver.push(el);
                        } else {
                            firstDataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                    localforage.setItem('first_Name', firstDataSaver);
                }
                return item;
            }),
        );
    };

    // 目的港下拉
    const lastChange = (value, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.destinationCity = value;
                    let dataSaverList = {
                        id: item.id,
                        value: value,
                    };
                    let dataSaverListAll = [];
                    dataSaverListAll.unshift(dataSaverList);
                    dataSaverListAll.forEach((el) => {
                        if (!dataSaver.some((e) => e.id === el.id)) {
                            dataSaver.push(el);
                        } else {
                            dataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                    localforage.setItem('last_Name', dataSaver);
                }

                return item;
            }),
        );
    };

    // 选择日期
    const timeChange = (value, dateString, text, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.timeValue = dateString;
                    const timeData = {
                        id: item.id,
                        value: dateString,
                    };
                    let timeList = [];
                    timeList.unshift(timeData);
                    timeList.forEach((el) => {
                        if (!timeDataSaver.some((e) => e.id === el.id)) {
                            timeDataSaver.push(el);
                        } else {
                            timeDataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                }
                localforage.setItem('time', timeDataSaver);
                return item;
            }),
        );
    };

    const weightChange = (v, record) => {
        let id = record.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id) {
                    item.cargo_weight = v;
                    const weightList = {
                        id: item.id,
                        value: v,
                    };
                    let weightListAll = [];
                    weightListAll.unshift(weightList);
                    weightListAll.forEach((el) => {
                        if (!weightDataSaver.some((e) => e.id === el.id)) {
                            weightDataSaver.push(el);
                        } else {
                            weightDataSaver.map((item) => {
                                if (item.id === el.id) {
                                    item.value = el.value;
                                }
                                return item;
                            });
                        }
                    });
                }
                localforage.setItem('weight', weightDataSaver);
                return item;
            }),
        );
    };

    // 锁定
    const locked = (text, record, index) => {
        let id = text.id;
        setState(
            dataSource.map((item) => {
                if (item.id === id && item.destinationCity !== '' && item.cargo_weight !== '') {
                    // item.isDisabled = true;
                    const params = {
                        name: item.name,
                        origin_location: item.originCity ? item.originCity : 'NINGBO',
                        destination_location: item.destinationCity,
                        cargo_weight: item.cargo_weight,
                        earliest_departure_date: item.timeValue,
                    };
                    ajax.post(
                        `/cma/check?name=${params.name}&origin_location=${params.origin_location}&destination_location=${params.destination_location}&cargo_weight=${params.cargo_weight}&earliest_departure_date=${params.earliest_departure_date}`,
                    )
                        .then((response) => {
                            if (response !== null) {
                                message.success(response);
                                console.log(response);
                            }
                        })
                        .catch((err) => {
                            // message.error(err.response.data.msg);
                            console.log(err.response.data.msg);
                        });
                }
                return item;
            }),
        );
        setState(
            dataSource.map((item) => {
                if (item.id === id && item.destinationCity === '') {
                    message.warning('请选择目的港');
                } else if (item.id === id && item.cargo_weight === '') {
                    message.warning('请输入载重');
                }
                return item;
            }),
        );
    };

    // 勾选锁定
    const checkLock = () => {
        if (selectedRowsValue.length === 0) {
            message.warning('请选择数据');
            return;
        }
        if (selectedRowsValue.some((item) => item.destinationCity === '')) {
            message.warning('请选择目的港');
            return;
        } else if (selectedRowsValue.some((item) => item.isDisabled !== false)) {
            message.warning('请选择未锁定的数据');
            return;
        } else if (selectedRowsValue.some((item) => item.cargo_weight === '')) {
            message.warning('请输入载重');
        } else {
            setSelectedRows(
                selectedRowsValue.forEach((item) => {
                    // item.isDisabled = true;
                    const params = {
                        name: item.name,
                        origin_location: item.originCity ? item.originCity : 'NINGBO',
                        destination_location: item.destinationCity,
                        cargo_weight: item.cargo_weight,
                        earliest_departure_date: item.timeValue,
                    };
                    ajax.post(
                        `/cma/check?name=${params.name}&origin_location=${params.origin_location}&destination_location=${params.destination_location}&cargo_weight=${params.cargo_weight}&earliest_departure_date=${params.earliest_departure_date}`,
                    )
                        .then((response) => {
                            // message.success(response);
                            console.log(response);
                        })
                        .catch((err) => {
                            item.isDisabled = false;
                            console.log(err);
                        });
                }),
            );
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center',
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '用户名',
            dataIndex: 'name',
            align: 'center',
            sorter: (a, b) => a['name'].localeCompare(b['name']),
        },
        {
            title: 'affiliates',
            dataIndex: 'affiliates',
            align: 'center',
            sorter: (a, b) => a['affiliates'].localeCompare(b['affiliates']),
        },
        {
            title: 'correlation',
            dataIndex: 'correlation',
            align: 'center',
            sorter: (a, b) => a['correlation'].localeCompare(b['correlation']),
        },
        {
            title: 'token',
            dataIndex: 'fresh_token',
            align: 'center',
            sorter: (a, b) => a['fresh_token'].localeCompare(b['fresh_token']),
        },
        {
            title: '起始港',
            dataIndex: 'firstName',
            align: 'center',
            type: 'select',
            render: (text, record, index) => {
                let options = firstNameArr.map((item) => {
                    return { label: item, value: item };
                });
                let FirstName = firstDataSaver.filter((e) => e.id === record.id);
                return (
                    <Select
                        showSearch
                        onChange={(value) => firstChange(value, text, record)}
                        defaultValue={FirstName.length ? FirstName : 'NINGBO'}
                        // defaultValue={firstDataSaver.filter((e) => e.id === record.id)}
                        style={{ width: 120 }}
                        options={options}
                    ></Select>
                );
            },
        },
        {
            title: '目的港',
            dataIndex: 'lastName',
            align: 'center',
            render: (text, record) => {
                let options = lastNameArr.map((item) => {
                    return { label: item, value: item };
                });
                return (
                    <Select
                        defaultValue={dataSaver.filter((e) => e.id === record.id)}
                        showSearch
                        onChange={(value) => lastChange(value, text, record)}
                        style={{ width: 120 }}
                        options={options}
                    ></Select>
                );
            },
        },
        {
            title: '载重',
            dataIndex: 'cargo_weight',
            align: 'center',
            render: (text, record) => {
                let FirstWeight = weightDataSaver.filter((e) => e.id === record.id);
                if (FirstWeight.length) {
                    FirstWeight.map((item) => {
                        if (item.value === '') {
                            item.value = '18600';
                        }
                        return item;
                    });
                }
                return (
                    <Input
                        defaultValue={FirstWeight.length ? FirstWeight[0].value : '18600'}
                        onChange={(e) => weightChange(e.target.value, record)}
                        style={{ width: 120 }}
                    ></Input>
                );
            },
        },
        {
            title: '日期',
            dataIndex: 'time',
            align: 'center',
            render: (text, record) => {
                let timeDefault = dayjs(timeDataSaver.find((e) => e.id === record.id)?.value) || today;
                return (
                    <DatePicker
                        defaultValue={timeDefault}
                        allowClear={false}
                        onChange={(value, dateString) => timeChange(value, dateString, text, record)}
                        style={{ width: 120 }}
                    ></DatePicker>
                );
            },
        },
        {
            title: '操作',
            dataIndex: '',
            align: 'center',
            render: (text, record, index) => (
                <Button disabled={text.isDisabled} onClick={() => locked(text, record, index)} type="primary">
                    锁定
                </Button>
            ),
        },
    ];
    return (
        <div className="username-list">
            <PageHeader title="CMA账号列表" sticky></PageHeader>
            <Form className="formStyle"  autoComplete="off">
                <Card className="ax-search-card">
                    <Row gutter={[16, 24]} style={{ width: '100%' }}>
                        <Col offset={21} className="gutter-row">
                            <Form.Item>
                                <Button type="primary" onClick={checkLock}>
                                    勾选锁定
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Form>
            <Table
                className="List"
                rowSelection={rowSelection}
                rowKey={(record) => record.id}
                pagination={false}
                dataSource={dataSource}
                columns={columns}
            />
        </div>
    );
}
